'use client';

import { useEffect } from 'react';

import { useQueryState } from 'nuqs';

import { useGlobal } from '@/lib/global-store';

import { BookingJourney, type BookingJourneyProps } from '../components/booking-journey';
import { Text } from '../components/text';
import Sheet from './sheet';

export const BookingSheet = ({ bookingTypes, bookingComponents }: BookingJourneyProps) => {
  const { setOpenBook, openBook } = useGlobal();
  const [openParam, setOpenParam] = useQueryState('book');
  const [legacyOpenParam, setLegacyOpenParam] = useQueryState('bookings');

  // if the URL is set to auto-open the booking sheet, open it and clear the URL parameter
  useEffect(() => {
    if (openParam) {
      setOpenBook(true);
      setOpenParam(null);
    }

    if (legacyOpenParam) {
      setOpenBook(true);
      setLegacyOpenParam(null);
    }
  }, [openParam, setOpenBook, setOpenParam, legacyOpenParam, setLegacyOpenParam]);

  return (
    <Sheet title={'Make a Booking'} open={openBook} onOpenChange={setOpenBook}>
      {bookingTypes?.length ? (
        <BookingJourney bookingTypes={bookingTypes} bookingComponents={bookingComponents} />
      ) : (
        <Text element={'h3'} className={'flex grow items-center'}>
          There are no booking types available at this time.
        </Text>
      )}
    </Sheet>
  );
};
